// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

/* overridden by src/lib/themes/guiHelpers.js */

.input_input-form_wWmtn {
    height: 2rem;
    padding: 0 0.75rem;

    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 0.625rem;
    font-weight: bold;
    color: var(--text-primary);
    background-color: var(--input-background);

    border-width: 1px;
    border-style: solid;
    border-color: var(--ui-black-transparent);
    border-radius: 2rem;

    outline: none;
    cursor: text;
    transition: 0.25s ease-out; /* @todo: standardize with var */
    box-shadow: none;

    /*
        For truncating overflowing text gracefully
        Min-width is for a bug: https://css-tricks.com/flexbox-truncated-text
        @todo: move this out into a mixin or a helper component
    */
    min-width: 0;
}

.input_input-form_wWmtn:hover {
    border-color: var(--looks-secondary);
}

.input_input-form_wWmtn:focus {
    border-color: var(--looks-secondary);
    box-shadow: 0 0 0 0.25rem var(--looks-transparent);
}

.input_input-small_w4EQb {
    width: 3rem;
    padding: 0 0.5rem;
    text-overflow: clip;
    text-align: center;
}

/* Chrome, Safari, Edge, Opera */

.input_input-form_wWmtn::-webkit-outer-spin-button,
.input_input-form_wWmtn::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */

.input_input-form_wWmtn[type=number] {
    -moz-appearance: textfield;
}
`, "",{"version":3,"sources":["webpack://./src/components/forms/input.css"],"names":[],"mappings":"AAAA;sDACsD;;AAEtD,+CAA+C;;AAE/C,+CAA+C;;AAE/C;IACI,YAAY;IACZ,kBAAkB;;IAElB,2DAA2D;IAC3D,mBAAmB;IACnB,iBAAiB;IACjB,0BAA0B;IAC1B,yCAAyC;;IAEzC,iBAAiB;IACjB,mBAAmB;IACnB,yCAAyC;IACzC,mBAAmB;;IAEnB,aAAa;IACb,YAAY;IACZ,0BAA0B,EAAE,gCAAgC;IAC5D,gBAAgB;;IAEhB;;;;KAIC;IACD,YAAY;AAChB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,kDAAkD;AACtD;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,gCAAgC;;AAEhC;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA,YAAY;;AAEZ;IACI,0BAA0B;AAC9B","sourcesContent":["/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n/* overridden by src/lib/themes/guiHelpers.js */\n\n.input-form {\n    height: 2rem;\n    padding: 0 0.75rem;\n\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    font-size: 0.625rem;\n    font-weight: bold;\n    color: var(--text-primary);\n    background-color: var(--input-background);\n\n    border-width: 1px;\n    border-style: solid;\n    border-color: var(--ui-black-transparent);\n    border-radius: 2rem;\n\n    outline: none;\n    cursor: text;\n    transition: 0.25s ease-out; /* @todo: standardize with var */\n    box-shadow: none;\n\n    /*\n        For truncating overflowing text gracefully\n        Min-width is for a bug: https://css-tricks.com/flexbox-truncated-text\n        @todo: move this out into a mixin or a helper component\n    */\n    min-width: 0;\n}\n\n.input-form:hover {\n    border-color: var(--looks-secondary);\n}\n\n.input-form:focus {\n    border-color: var(--looks-secondary);\n    box-shadow: 0 0 0 0.25rem var(--looks-transparent);\n}\n\n.input-small {\n    width: 3rem;\n    padding: 0 0.5rem;\n    text-overflow: clip;\n    text-align: center;\n}\n\n/* Chrome, Safari, Edge, Opera */\n\n.input-form::-webkit-outer-spin-button,\n.input-form::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n/* Firefox */\n\n.input-form[type=number] {\n    -moz-appearance: textfield;\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `input_input-form_wWmtn`;
export { _1 as "input-form" };
export var inputForm = `input_input-form_wWmtn`;
var _2 = `input_input-small_w4EQb`;
export { _2 as "input-small" };
export var inputSmall = `input_input-small_w4EQb`;
export default ___CSS_LOADER_EXPORT___;
